import styled from "styled-components";

export const CMVideo = styled.div(props => ({
    width: props.width,
    height: props.height,
    margin: '0 5px',
    cursor: 'pointer',
    [`@media (min-width: 2000px)`]: {
        width: "25vh",
        height: "auto"
    },
    "& > div":{
        [`@media (min-width: 2000px)`]: {
            width: "25vh !important",
            height: "auto",
            "& div": {
                width: "25vh",
                height: "15vh"
            },
            "& img": {
                width: "25vh",
                height: "15vh",
                borderRadius:"2vh !important"
            },
            "& div": {
                width: "25vh",
                height: "15vh"
            }
        },
    }

    // [`@media ${props.theme.breakpoints.xs}`]: {
    //     width: '100%',

    //     'iframe, img': {
    //         width: '100%',
    //     },
    // }
}));

export const VideoModal = styled.div(props => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 400,
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: 24,
    border: 'none !important',
    outline: '0 !important',
    padding: '1.5rem',

    [`@media (min-width: 2000px)`]: {
        width: "80%",
        height: "80%",
        "& iframe document html body video":{
            width: "100%",
            height: "100%",
        }
    },


    [`@media${props.theme.breakpoints.md}`]: {
        width: "90%",
        height: "40%"
      },
    [`@media${props.theme.breakpoints.sm}`]: {
    width: "80%",
    height: "30%"
    },

}))
